import { z } from "zod";
import { PractitionerSessionSchema } from "./practitioner-sessions.js";
// Someone expected at a session.
//
// Not "participant" or "member": the org's word — and ICIS's entity — is
// attendance. "Roster" means staff rostering here.
// Whether someone has been marked as having attended.
//
// Two states because the list carries two: everyone on it is either marked
// attended or still only invited, and the practitioner's one action moves
// between them. Every other ICIS status — absent, cancelled, postponed,
// rescheduled, not required, arrived — is filtered out by the service, so there
// is no state here to describe them.
//
// Named rather than a boolean, and named as ICIS does: `invited` is a status a
// record actually holds, where `false` would equally read as "recorded
// absent".
export const AttendanceStateSchema = z.enum(["attended", "invited"]);
export const AttendeeSchema = z.object({
    contactId: z.guid(),
    firstName: z.string(),
    lastname: z.string(),
    attendance: AttendanceStateSchema,
    hasGivenFeedback: z.boolean(),
});
// Where a participant goes to give feedback. The same address for every session
// (ADR-029 D5).
//
// Absolute, because the portal is served from its own hostname and the feedback
// app is not on it — a link resolved against this page's origin reaches nothing.
export const FeedbackLinkSchema = z.url();
// One session and everyone expected at it, cancelled attendance excluded.
//
// `session` is the same shape the day list carries, reused rather than restated:
// the page's header wants exactly what a day-list row wants — the time, the name
// and the program — and a second shape for the same record would drift.
export const SessionAttendanceResponseSchema = z.object({
    session: PractitionerSessionSchema,
    attendees: z.array(AttendeeSchema),
    feedbackLink: FeedbackLinkSchema,
});
// Marking one person's attendance. Carries the state to move to rather than a
// bare "mark present", so correcting a mis-tap is the same request in reverse.
export const MarkAttendanceRequestSchema = z.object({
    attendance: AttendanceStateSchema,
});
